<template>
  <div class="panel-title">
    <component :is="h" class="mb-2" :class="['font-weight-'+weight, textColor]">
      <div class="d-flex align-center flex-wrap">
        <v-icon left :color="iconColor" v-text="icon"></v-icon>
        <span v-text="title" v-if="!$slots.title"></span>
        <slot name="title"></slot>
        <v-spacer></v-spacer>
        <slot name="append-inner"></slot>
      </div>
      <v-divider class="mt-2"></v-divider>
    </component>
    <div class="d-flex">
    <p class="text-caption grey--text text--darken-2 mb-2" v-text="desc"></p>
    <slot name="append-inner-subtitle"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelTitle",
  props: {
    h: {
      type: String,
      default: "h1"
    },
    title: {
      type: String
    },
    icon: {
      type: String
    },
    iconColor: {
      type: String,
      default: "black"
    },
    textColor: {
      type: String,
      default: "black--text"
    },
    desc: {
      type: String
    },
    weight: {
      type: String,
      default: "light"
    }
  }
};
</script>

<style scoped>
.panel-title h1 {
  font-size: 1.25rem;
}
</style>